module.exports = __webpack_public_path__ + "static/media/HomeStoryLogo2.0e536583.png";